import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function availableDatesReducer(
  state = initialState.availableDates,
  action
) {
  switch (action.type) {
    case types.LOAD_AVAILABLE_DATES_SUCCESS:
      return action.availableDates;
    case types.RESET_AVAILABLE_DATES_SUCCESS:
      return initialState.availableDates;
    default:
      return state;
  }
}
